import { useNavigation } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';

import { AchievementsScreen } from '../components/AchievementsScreen';
import { GamificationDashboard } from '../components/GamificationDashboard';
import { StreakCalendarScreen } from '../components/StreakCalendarScreen';
import { XPLeaderboardScreen } from '../components/XPLeaderboardScreen';

export type GamificationStackParamList = {
  GamificationDashboard: undefined;
  Achievements: undefined;
  StreakCalendar: undefined;
  XPLeaderboard: undefined;
};

const Stack = createStackNavigator<GamificationStackParamList>();

const GamificationNavigator: React.FC = () => {
  return (
    <Stack.Navigator
      initialRouteName="GamificationDashboard"
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen 
        name="GamificationDashboard" 
        component={GamificationDashboardWrapper}
      />
      <Stack.Screen 
        name="Achievements" 
        component={AchievementsScreen}
      />
      <Stack.Screen 
        name="StreakCalendar" 
        component={StreakCalendarScreen}
      />
      <Stack.Screen 
        name="XPLeaderboard" 
        component={XPLeaderboardScreen}
      />
    </Stack.Navigator>
  );
};

// Wrapper component to handle navigation
const GamificationDashboardWrapper: React.FC = () => {
  const navigation = useNavigation();

  return (
    <GamificationDashboard
      onNavigateToAchievements={() => navigation.navigate('Achievements' as never)}
      onNavigateToStreakCalendar={() => navigation.navigate('StreakCalendar' as never)}
      onNavigateToLeaderboard={() => navigation.navigate('XPLeaderboard' as never)}
    />
  );
};

export default GamificationNavigator;